import React from "react";
import "./styles.css";

const RangeSlider = ({
  min,
  max,
  name,
  item_name,
  showSlider,
  hideSlider,
  inputRef,
  qty,
  handleValue,
  handleAction
}) => {
  return (
    <div className={showSlider ? "slidecontainer" : "slidecontainer-hidden"}>
      <div className="slide-wrap">
        <p className="prompt-name">
          {item_name.replace(/^\w/, (c) => c.toUpperCase())} ({qty})
        </p>
        <br />
        <input
          type="range"
          min={min}
          max={max}
          value={qty}
          className="slider"
          ref={inputRef}
          id="myRange"
          onChange={(e, name) => {
            handleValue(e, name);
          }}
        />
      </div>
      <div className="btn-container">
        <button
          onClick={(e) => {
            handleAction(item_name, qty, name);
          }}
        >
          {name}
        </button>
        <button onClick={hideSlider}>Cancel</button>
      </div>
    </div>
  );
};

export default RangeSlider;
